import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularIndeterminate from 'Components/loader/CircularIndeterminate';
import { getAccessToken } from 'src/store/actions/auth';
import { useAuth } from 'Hooks/useAuth';
import { Link as RouterLink } from 'react-router-dom';
import { ENDPOINTS } from '../../../constants';

const StyledContainer = styled(Container)`
  max-width: 600px;
  margin-top: 150px;
`;

const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-weight: bold;
`;
const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;
function LoginRedirect() {
  const { login, logout } = useAuth();
  const [isAuth, setIsAuth] = useState(null);
  const [isSigningIn, setIsSigningIn] = useState(true);
  const [isUserAuthorized, setIsUserAuthorized] = useState(null);
  const [unAuthorizedErrorMessage, setUnAuthorizedErrorMessage] = useState('');

  const setUserValid = (userStatus) => {
    // setValidUser(userStatus);
  };

  useEffect(() => {
    let controller = new AbortController();
    const fetchData = async () => {
      const res = await getAccessToken(setIsAuth, setIsSigningIn);
      if (res.response.status === 403) {
        throw Error(res.response.data.error);
      }

      controller = null;

      return res;
    };

    fetchData().catch((e) => {
      setIsUserAuthorized(false);
      setUnAuthorizedErrorMessage(e.message);
    });
    return () => controller?.abort();
  }, []);

  useEffect(() => {
    if (!isSigningIn) {
      !isAuth ? logout() : login();
    }
  }, [isAuth, isSigningIn]);

  return (
    <>
      {
        <Dialog
          open={isUserAuthorized === false}
          disableEscapeKeyDown
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {unAuthorizedErrorMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              component={RouterLink}
              to={ENDPOINTS.logoutUrl}
              color='primary'
              variant='outlined'
              // onClick={() => dialogCloseHandler(DialogResult.YES)}
              autoFocus
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      }
      <Helmet>
        <title>Checking Authentication</title>
      </Helmet>
      <StyledBox>
        <StyledContainer maxWidth='md'>
          <StyledTypography align='center' variant='h1'>
            Please hold, checking authentication...
          </StyledTypography>
          <Box sx={{ textAlign: 'center' }}>
            <CircularIndeterminate />
          </Box>
        </StyledContainer>
      </StyledBox>
    </>
  );
}

export default LoginRedirect;
